/**
 * Created by Victor Rojo on 8/10/18.
 */
import { Injectable, Optional }     from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';

@Injectable()
export class StatusNotificationService{

  private basePath = "api/v1/";
  constructor(
    private http: HttpClient
  ) { }

  private errorHandler(error: any): Promise<any> {
    console.log('An error occurred', error);
    return Promise.reject(error.message || error);
  }

  solveStatusNotification(statusNotificationId:string, solvedDescription:string): Promise<any>{
    let url = this.basePath + "status_notification/" + statusNotificationId + "/solve";
    const data = {
      description: solvedDescription
    }
    return this.http.post(url, data, { responseType: 'text' })
      .toPromise()
      .catch( error => this.errorHandler(error) );
  }
}
